export default {
  createSuccess: "Gastgeber erfolgreich erstellt!",
  createModal: {
    title: "Neuen Gastgeber hinzufügen",
    namePlaceholder: "z. B. Villa Panorama",
    emailPlaceholder: "gastgeber@beispiel.de",
    create: "Gastgeber erstellen",
  },
  detail: {
    roleLabel: "Gastgeber",
    statStructures: "Strukturen",
    loadDetail: "Gastgeberdetails werden geladen...",
    loadError: "Gastgeber konnte nicht geladen werden",
    toastStatusUpdated: "Gastgeberstatus aktualisiert",
    toastStatusError: "Gastgeberstatus konnte nicht aktualisiert werden",
    toastPasswordResetSent:
      "E-Mail zum Zurücksetzen des Passworts an den Gastgeber gesendet.",
    housesTitle: "Strukturen",
    noHouses: "Noch keine Strukturen",
    activitiesTitle: "Aktivitäten ({{count}})",
    loadActivities: "Aktivitäten werden geladen...",
    activitiesError: "Aktivitäten konnten nicht geladen werden",
    noActivitiesTitle: "Keine Aktivitäten",
    noActivitiesDesc: "Dieser Gastgeber hat noch keine Aktivitäten",
  },
} as const;
